import React from 'react'
import { Link } from "react-router-dom";


const HomeBanner = () => {
    return (
        <>
            <section className="banner" style={{ background: 'url(assets/img/banner_1.webp)' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-xl-7 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="banner_text">
                                <h5> One Company for Multiple Professional Service</h5>
                                <h1 style={{fontSize:"40px"}}>Your Growth Our Commitment</h1>
                                <p style={{color:"white"}}><b>Sewax Services Private Limited offers a wide range of professional services; our experienced team delivers reliable, effective solutions tailored to your specific needs.</b></p>
                                <ul className="d-flex flex-wrap align-items-center">
                                    <li>
                                        <Link className="common_btn" to="/contact-us">Book Appointment <i className="far fa-long-arrow-right" aria-hidden="true" /></Link>
                                    </li>
                                    <li>
                                        <Link className="play_btn" to="https://wa.me/+919174282618" target="blank">
                                            <i className=" fas fa-play" aria-hidden="true" />
                                        </Link>
                                        <span>Watch Our Story</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-5 col-xl-5 wow fadeInRight" style={{ visibility: 'visible', animationName: 'fadeInRight' }}>
                            <div className="banner_img">
                                <div className="img" >
                                    <img style={{marginTop:"0px"}} src="assets/img/c.webp" alt="Banner" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default HomeBanner